// Bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// Mobx
import { action, observable } from 'mobx';

export enum AccountDataState {
  NOT_INITIALIZED, PENDING, INITIALIZED, FAILED,
}

export class AccountDataStateStore extends Store {

  @observable
  public status: AccountDataState;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.status = AccountDataState.NOT_INITIALIZED;
  }

  @action
  public markNotInitialized() {
    this.status = AccountDataState.NOT_INITIALIZED;
  }

  @action
  public markAsPending() {
    this.status = AccountDataState.PENDING;
  }

  @action
  public markAsInitialized() {
    this.status = AccountDataState.INITIALIZED;
  }

  @action
  public markAsFailed() {
    this.status = AccountDataState.FAILED;
  }

  public hydrate(data: SerializedData): void {
    //noop
  }
}
